import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoveAndAssignErrorOverlayMessage = ({
  message
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column justify-center p-x-6",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "warning"
    }), message]
  });
};
MoveAndAssignErrorOverlayMessage.displayName = 'MoveAndAssignErrorOverlayMessage';
export default MoveAndAssignErrorOverlayMessage;